export const VIDEO_FORMATS = [
  "3gp",
  "3g2",
  "avi",
  "divx",
  "flv",
  "mkv",
  "mov",
  "qt",
  "mp4",
  "m4v",
  "mpeg",
  "mpg",
  "ogg",
  "webm",
  "wmv",
  "m2ts",
  "mts",
  "ts",
  "vob",
  "wtv",
  "mxf",
  "rm",
  "rmvb",
  "dvr-ms"
];
